import useSWR from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const me = (token) => Manager.client(token).get(Endpoints.users.me);
const updateMe = (token, values) =>
  Manager.client(token).post(Endpoints.users.me, values);

export const UseMe = ({ access }) => {
  const { data, error } = useSWR(`${Endpoints.users.me}/${access}`, () =>
    me(access),
  );

  return {
    content: data ? data.data.data : null,
    error,
    loading: !error && !data,
  };
};

export const Request = {
  me,
  updateMe,
};
